import { KtznAuthErrorResponse } from "@/modules/auth/services/ktznAuthenticationService";

/* eslint-disable no-redeclare */
class KtznAuthenticationError extends Error {
  /** Error type */
  type: KtznAuthenticationError.Type;
  errorData?: KtznAuthErrorResponse;

  constructor(
    type: KtznAuthenticationError.Type = KtznAuthenticationError.Type.general,
    errorData?: KtznAuthErrorResponse,
    ...params: any[]
  ) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, KtznAuthenticationError);
    }

    this.name = "KtznAuthenticationError";
    // Custom debugging information
    this.type = type;
    this.errorData = errorData;
  }
}

namespace KtznAuthenticationError {
  export enum Type {
    /** A general JavaScript error */
    general,
    /** Requesting the login (`/login/request`) failed */
    loginRequestFailed,
    /** Requesting the accept login (`/login/accept`) failed */
    loginAcceptFailed,
    /** Authentication refresh with Kotozna Auth (`/user/auth/refresh`) failed */
    authRefreshFailed,
    /** Getting the Kotozna access token failed */
    noKtznAccessToken,
    /** Getting the Kotozna refresh token failed */
    noKtznRefreshToken,
  }
}

export default KtznAuthenticationError;
